"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _form = require("../../form");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var CTAWrapper = ( /*#__PURE__*/0, _styledBase.default)('div', {
  target: "e70shzq0",
  label: "CTAWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "s2uf1z",
  styles: "text-align:right;"
} : {
  name: "s2uf1z",
  styles: "text-align:right;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL3VpX2VsZW1lbnRzL25vdGlmaWNhdGlvbnMvTm90aWZpY2F0aW9uQ1RBLmpzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFLZ0MiLCJmaWxlIjoiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvdWlfZWxlbWVudHMvbm90aWZpY2F0aW9ucy9Ob3RpZmljYXRpb25DVEEuanN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcclxuaW1wb3J0IFByb3BUeXBlcyBmcm9tICdwcm9wLXR5cGVzJztcclxuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xyXG5pbXBvcnQgeyBCdXR0b24gfSBmcm9tICcuLi8uLi9mb3JtJztcclxuXHJcbmNvbnN0IENUQVdyYXBwZXIgPSBzdHlsZWQoJ2RpdicpYFxyXG4gIHRleHQtYWxpZ246IHJpZ2h0O1xyXG5gO1xyXG5cclxuY29uc3QgTm90aWZpY2F0aW9uQ1RBID0gKHByb3BzKSA9PiB7XHJcbiAgY29uc3Qge1xyXG4gICAgZGVjbGluZUJ1dHRvbk1zZyxcclxuICAgIGFjY2VwdEJ1dHRvbk1zZyxcclxuICAgIGhhbmRsZURlY2xpbmUsXHJcbiAgICBoYW5kbGVBY2NlcHRcclxuICB9ID0gcHJvcHM7XHJcblxyXG4gIHJldHVybiAoXHJcbiAgICA8Q1RBV3JhcHBlcj5cclxuICAgICAgPEJ1dHRvbiBvbkNsaWNrPXtoYW5kbGVEZWNsaW5lfT5cclxuICAgICAgICB7ZGVjbGluZUJ1dHRvbk1zZ31cclxuICAgICAgPC9CdXR0b24+XHJcbiAgICAgIDxCdXR0b24gb25DbGljaz17aGFuZGxlQWNjZXB0fSB2YXJpYW50PVwic2Vjb25kYXJ5XCI+XHJcbiAgICAgICAge2FjY2VwdEJ1dHRvbk1zZ31cclxuICAgICAgPC9CdXR0b24+XHJcbiAgICA8L0NUQVdyYXBwZXI+XHJcbiAgKTtcclxufTtcclxuXHJcbk5vdGlmaWNhdGlvbkNUQS5wcm9wVHlwZXMgPSB7XHJcbiAgZGVjbGluZUJ1dHRvbk1zZzogUHJvcFR5cGVzLnN0cmluZy5pc1JlcXVpcmVkLFxyXG4gIGFjY2VwdEJ1dHRvbk1zZzogUHJvcFR5cGVzLnN0cmluZy5pc1JlcXVpcmVkLFxyXG4gIGhhbmRsZURlY2xpbmU6IFByb3BUeXBlcy5mdW5jLmlzUmVxdWlyZWQsXHJcbiAgaGFuZGxlQWNjZXB0OiBQcm9wVHlwZXMuZnVuYy5pc1JlcXVpcmVkXHJcbn07XHJcblxyXG5leHBvcnQgZGVmYXVsdCBOb3RpZmljYXRpb25DVEE7XHJcbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

var NotificationCTA = function NotificationCTA(props) {
  var declineButtonMsg = props.declineButtonMsg,
      acceptButtonMsg = props.acceptButtonMsg,
      handleDecline = props.handleDecline,
      handleAccept = props.handleAccept;
  return /*#__PURE__*/_react.default.createElement(CTAWrapper, null, /*#__PURE__*/_react.default.createElement(_form.Button, {
    onClick: handleDecline
  }, declineButtonMsg), /*#__PURE__*/_react.default.createElement(_form.Button, {
    onClick: handleAccept,
    variant: "secondary"
  }, acceptButtonMsg));
};

NotificationCTA.propTypes = {
  declineButtonMsg: _propTypes.default.string.isRequired,
  acceptButtonMsg: _propTypes.default.string.isRequired,
  handleDecline: _propTypes.default.func.isRequired,
  handleAccept: _propTypes.default.func.isRequired
};
var _default = NotificationCTA;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@contently/toolkit/dist/ui_elements/notifications/NotificationCTA.js
// module id = 757
// module chunks = 0 15 16 17 18